import { createComponent } from "@front/utils/alpine";
import prestashop from 'prestashop';

export default createComponent(() => ({

    reloadLocation () {
        const select : HTMLSelectElement = this.$event.target ;
        const value = parseInt(select.value)
        let url = new URL(prestashop.urls.pages.contact);
        if(value > 0) url.searchParams.set('id_store', select.value)
        window.location.assign(url.href);
    }
}));
